import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  lineNo: {
    type: "number",
    name: "lineNo",
    label: "Line No",
    disabled: true,
    required: true,
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  poNumber: {
    type: "text",
    name: "poNumber",
    label: "PO Number",
    maxLength: 20,
    disabled: true,
  },
  extPONumber: {
    type: "text",
    name: "extPONumber",
    label: "ExtPO Number",
    maxLength: 20,
    disabled: true,
  },
  skuCode: {
    type: "text",
    name: "skuCode",
    label: "SKU Code",
    errorMsg: "SKU Code is required",
    maxLength: 50,
    required: true,
    disabled: true,
  },
  packType: {
    type: "text",
    name: "packType",
    label: "Pack Type",
    errorMsg: "Pack Type is required",
    maxLength: 10,
    required: true,
    disabled: true,
  },
  qtyExpected: {
    type: "number",
    name: "qtyExpected",
    label: "Quantity Expected",
    errorMsg: "Quantity Expected is required",
    required: true,
  },
  qtyAvailable: {
    type: "number",
    name: "qtyAvailable",
    label: "Quantity Available",
    disabled: true,
  },
  baseUOM: {
    type: "text",
    name: "baseUOM",
    label: "Base UOM",
    maxLength: 10,
    disabled: true,
  },
  vDONo: {
    type: "text",
    name: "vDONo",
    label: "DO No",
    maxLength: 20,
  },
  vInvNo: {
    type: "text",
    name: "vInvNo",
    label: "Invoice No",
    maxLength: 20,
  },
  mln: {
    type: "text",
    name: "mln",
    label: "MLN",
    maxLength: 20,
  },
  manufacturingDate: {
    type: "date",
    name: "manufacturingDate",
    label: "Manufacturing Date",
  },
  expiryDate: {
    type: "date",
    name: "expiryDate",
    label: "Expiry Date",
  },
  remark: {
    type: "text",
    name: "remark",
    label: "Remark",
    maxLength: 300,
  },
};

const {
  lineNo,
  status,
  poNumber,
  extPONumber,
  skuCode,
  packType,
  qtyExpected,
  baseUOM,
  vDONo,
  vInvNo,
  mln,
  manufacturingDate,
  expiryDate,
  remark,

  qtyAvailable,
} = formField;

// export const detailRender = [
//   [lineNo, status],
//   [poNumber, extPONumber],
//   [{ type: "line" }],
//   [skuCode, packType],
//   [qtyExpected, baseUOM],
//   [{ type: "line" }],
//   [vDONo, vInvNo],
//   [mln],
//   [manufacturingDate, expiryDate],
//   [{ type: "line" }],
//   [remark],
// ];

export const detailRender = [
  [lineNo, poNumber, extPONumber, status],
  [skuCode, packType, vDONo, vInvNo],
  [qtyExpected, baseUOM, manufacturingDate, expiryDate],
  [qtyAvailable, mln, remark],
];

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
  [poNumber.name]: Yup.string().nullable().max(poNumber.maxLength),
  [extPONumber.name]: Yup.string().nullable().max(extPONumber.maxLength),
  [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength).required(skuCode.errorMsg),
  [packType.name]: Yup.string().nullable().max(packType.maxLength).required(packType.errorMsg),
  [qtyExpected.name]: Yup.number().min(1).required(qtyExpected.errorMsg),
  [baseUOM.name]: Yup.string().nullable().max(baseUOM.maxLength),
  [vDONo.name]: Yup.string().nullable().max(vDONo.maxLength),
  [vInvNo.name]: Yup.string().nullable().max(vInvNo.maxLength),
  [status.name]: Yup.string().nullable(),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
  [mln.name]: Yup.string().nullable().max(mln.maxLength),
  [manufacturingDate.name]: Yup.string().nullable(),
  [expiryDate.name]: Yup.string().nullable(),
});
